import { PROFESSIONAL_CREDENTIALS } from "@constants/professionalCredentials";
import {
  Box,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

interface ProfessionalInfoProps {
  hasAttemptedValidation?: boolean;
  title?: string;
}

export default function ProfessionalInfo({
  hasAttemptedValidation = false,
  title = "2. Please select your professional credentials",
}: ProfessionalInfoProps) {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const professionalCredentials = watch("professionalCredentials");

  return (
    <Box>
      <CardHeader
        title={title}
        slotProps={{ title: { variant: "h5" } }}
      />
      <CardContent>
        <Typography gutterBottom>
          To enroll in the training and become eligible to use Unyte Health products, you must hold
          an accredited academic degree and a <b>valid and active license or credential</b> in one
          of the following listed professions:
        </Typography>

        <FormControl
          fullWidth
          sx={{ my: 3 }}
          error={hasAttemptedValidation && !!errors.professionalCredentials}
        >
          <InputLabel id="credentials-label">Professional Credentials*</InputLabel>

          <Controller
            name="professionalCredentials"
            control={control}
            rules={{ required: "Credential is required" }}
            render={({ field }) => (
              <Select
                autoFocus
                {...field}
                labelId="professional-credentials-label"
                id="professionalCredentials"
                label="Professional Credentials*"
              >
                {PROFESSIONAL_CREDENTIALS.map((cred) => (
                  <MenuItem key={cred} value={cred}>
                    {cred}
                  </MenuItem>
                ))}
              </Select>
            )}
          />

          {hasAttemptedValidation && errors.professionalCredentials?.message && (
            <FormHelperText>{errors.professionalCredentials.message.toString()}</FormHelperText>
          )}
          {professionalCredentials === "Other" && (
            <Typography gutterBottom pt={3}>
              Based on your selection, we need to verify your professional credentials.
            </Typography>
          )}
        </FormControl>
      </CardContent>
    </Box>
  );
}
